import { Theme } from '@material-ui/core/styles';
import type { Overrides } from '@material-ui/core/styles/overrides';
import hexToRgba from 'hex-to-rgba';

const overrides = (customTheme: Theme): Overrides => ({
  MuiButton: {
    root: {
      textTransform: 'none',
      minHeight: customTheme.spacing(5),
    },
    outlinedPrimary: {
      backgroundColor: hexToRgba(customTheme.palette.primary.main, 0.03),
    },
  },
  MuiLink: {
    underlineAlways: {
      textUnderlineOffset: '0.2em',
    },
  },
});

export default overrides;
